module.exports = __webpack_public_path__ + "img/simeon.e3319802.jpg";